import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "root" }

import SogGrid from '@/shared/ui/SogGrid.vue';


import SogCard from '@/shared/ui/SogCard.vue';
import SogCardContent from '@/shared/ui/SogCardContent.vue';
import SogCardTitle from '@/shared/ui/SogCardTitle.vue';

import RechercheMessage from '@/shared/model/RechercheMessage'

import SogDataLabel from '@/shared/ui/SogDataLabel.vue';
import {SogDataLabelValueType} from '@/shared/ui/types/SogDataLabelValueType'

import {DefaultColumn, DateTimeColumn} from '@/shared/ui/types/SogGridColumnDefinitions';

import SogIcon from '@/shared/ui/SogIcon.vue';

interface Props {
  rechercheMessage: RechercheMessage,
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*@__PURE__*/_defineComponent({
  __name: 'VbRechercheDetailsComponent',
  props: {
    rechercheMessage: { default: undefined }
  },
  setup(__props: any) {



const props = __props



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SogCard, { class: "card" }, {
      default: _withCtx(() => [
        _createVNode(SogCardTitle, { id: "title" }, {
          default: _withCtx(() => [
            _cache[0] || (_cache[0] = _createTextVNode(" Detailansicht VB ", -1)),
            _createVNode(SogIcon, {
              id: "icon",
              icon: __props.rechercheMessage?.gdvMessageMode === 'Online' ? 'mdi-web' : 'mdi-database'
            }, null, 8, ["icon"])
          ]),
          _: 1
        }),
        _renderSlot(_ctx.$slots, "default"),
        _createVNode(SogCardContent, { id: "content-container" }, {
          default: _withCtx(() => [
            _cache[1] || (_cache[1] = _createElementVNode("div", { id: "label" }, " VB-Nummer ", -1)),
            _createVNode(SogDataLabel, {
              class: "value",
              "value-type": _unref(SogDataLabelValueType).String,
              value: __props.rechercheMessage?.versicherungsbestaetigungsnummer
            }, null, 8, ["value-type", "value"]),
            _cache[2] || (_cache[2] = _createElementVNode("div", { id: "label" }, " VB-Status ", -1)),
            _createVNode(SogDataLabel, {
              class: "value",
              style: {"grid-column-start":"4","grid-column-end":"span 5"},
              "value-type": _unref(SogDataLabelValueType).String,
              value: __props.rechercheMessage?.vbStatusString
            }, null, 8, ["value-type", "value"]),
            _cache[3] || (_cache[3] = _createElementVNode("div", { id: "label" }, " VB-Einstelldatum ", -1)),
            _createVNode(SogDataLabel, {
              class: "value",
              "value-type": _unref(SogDataLabelValueType).Date,
              value: __props.rechercheMessage?.vbEinstelldatum
            }, null, 8, ["value-type", "value"]),
            _cache[4] || (_cache[4] = _createElementVNode("div", { id: "label" }, " Nutzererkennungs ", -1)),
            _createVNode(SogDataLabel, {
              class: "value",
              "value-type": _unref(SogDataLabelValueType).String,
              value: __props.rechercheMessage?.nutzerkennung
            }, null, 8, ["value-type", "value"])
          ]),
          _: 1
        })
      ]),
      _: 3
    }),
    _createVNode(SogCard, { class: "card" }, {
      default: _withCtx(() => [
        _createVNode(SogCardTitle, { id: "title" }, {
          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
            _createTextVNode(" Versicherung ", -1)
          ]))]),
          _: 1
        }),
        _createVNode(SogCardContent, { id: "content-container" }, {
          default: _withCtx(() => [
            _cache[6] || (_cache[6] = _createElementVNode("div", { id: "label" }, " Versicherer ", -1)),
            _createVNode(SogDataLabel, {
              class: "value",
              style: {"grid-column-end":"span 5","grid-column-start":"2"},
              "value-type": _unref(SogDataLabelValueType).String,
              value: __props.rechercheMessage?.versicherung?.name1
            }, null, 8, ["value-type", "value"]),
            _cache[7] || (_cache[7] = _createElementVNode("div", { id: "label" }, " Geschäftsstelle ", -1)),
            _createVNode(SogDataLabel, {
              class: "value",
              "value-type": _unref(SogDataLabelValueType).String,
              value: __props.rechercheMessage?.versicherung?.geschaeftsstelleVersicherung
            }, null, 8, ["value-type", "value"]),
            _cache[8] || (_cache[8] = _createElementVNode("div", { id: "label" }, " GDV-Vermittler-ID ", -1)),
            _createVNode(SogDataLabel, {
              class: "value",
              "value-type": _unref(SogDataLabelValueType).String,
              value: __props.rechercheMessage?.gdvVermittlernummer
            }, null, 8, ["value-type", "value"]),
            _cache[9] || (_cache[9] = _createElementVNode("div", { id: "label" }, " VB abrufbar bis ", -1)),
            _createVNode(SogDataLabel, {
              class: "value",
              "value-type": _unref(SogDataLabelValueType).Date,
              value: __props.rechercheMessage?.vbAbrufbarBis
            }, null, 8, ["value-type", "value"]),
            _cache[10] || (_cache[10] = _createElementVNode("div", { id: "label" }, " Agentnummer ", -1)),
            _createVNode(SogDataLabel, {
              class: "value",
              "value-type": _unref(SogDataLabelValueType).String,
              value: __props.rechercheMessage?.versicherung?.agenturVersicherung
            }, null, 8, ["value-type", "value"]),
            _cache[11] || (_cache[11] = _createElementVNode("div", { id: "label" }, " VU-interne Vermittlugnsnummer ", -1)),
            _createVNode(SogDataLabel, {
              class: "value",
              "value-type": _unref(SogDataLabelValueType).String,
              value: __props.rechercheMessage?.vuInterneVermittlernummer
            }, null, 8, ["value-type", "value"]),
            _cache[12] || (_cache[12] = _createElementVNode("div", { id: "label" }, " Vers. Beginn ", -1)),
            _createVNode(SogDataLabel, {
              class: "value",
              "value-type": _unref(SogDataLabelValueType).String,
              value: __props.rechercheMessage?.versicherung?.datumVersicherungsbeginn
            }, null, 8, ["value-type", "value"]),
            _cache[13] || (_cache[13] = _createElementVNode("div", { id: "label" }, " VB Art ", -1)),
            _createVNode(SogDataLabel, {
              class: "value",
              "value-type": _unref(SogDataLabelValueType).String,
              value: __props.rechercheMessage?.vbArtDescription
            }, null, 8, ["value-type", "value"]),
            _cache[14] || (_cache[14] = _createElementVNode("div", { id: "label" }, " Zulassungsfahrten ", -1)),
            _createVNode(SogDataLabel, {
              class: "value",
              "value-type": _unref(SogDataLabelValueType).String,
              value: __props.rechercheMessage?.zulassungsfahrten == '0' ? 'Nein' : 'Ja'
            }, null, 8, ["value-type", "value"]),
            _cache[15] || (_cache[15] = _createElementVNode("div", { id: "label" }, " Versicherungsscheinnr. ", -1)),
            _createVNode(SogDataLabel, {
              class: "value",
              "value-type": _unref(SogDataLabelValueType).String,
              value: __props.rechercheMessage?.versicherung?.versicherungsscheinnummer
            }, null, 8, ["value-type", "value"]),
            _cache[16] || (_cache[16] = _createElementVNode("div", { id: "label" }, " Unternehmentsart ", -1)),
            _createVNode(SogDataLabel, {
              class: "value",
              style: {"grid-column-start":"2","grid-column-end":"span 3"},
              "value-type": _unref(SogDataLabelValueType).String,
              value: __props.rechercheMessage?.versicherung?.unternehmensartDescription
            }, null, 8, ["value-type", "value"]),
            _cache[17] || (_cache[17] = _createElementVNode("div", {
              id: "label",
              style: {"grid-row-start":"6"}
            }, " Int. Vermerke ", -1)),
            _createVNode(SogDataLabel, {
              class: "value",
              style: {"grid-column-start":"2","grid-column-end":"span 5"},
              "value-type": _unref(SogDataLabelValueType).String,
              value: __props.rechercheMessage?.versicherung?.interneVermerkeVersicherung
            }, null, 8, ["value-type", "value"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(SogCard, { class: "card" }, {
      default: _withCtx(() => [
        _createVNode(SogCardTitle, { id: "title" }, {
          default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
            _createTextVNode(" Versicherungsnehmer ", -1)
          ]))]),
          _: 1
        }),
        _createVNode(SogCardContent, { id: "content-container" }, {
          default: _withCtx(() => [
            _cache[19] || (_cache[19] = _createElementVNode("div", { id: "label" }, " Name Jur. Person ", -1)),
            _createVNode(SogDataLabel, {
              class: "value",
              style: {"grid-column-end":"span 5","grid-column-start":"2"},
              "value-type": _unref(SogDataLabelValueType).String,
              value: __props.rechercheMessage?.versicherungsnehmer?.juristischePerson?.nameJuristischePerson 
            }, null, 8, ["value-type", "value"]),
            _cache[20] || (_cache[20] = _createElementVNode("div", { id: "label" }, " Name Vereinigung ", -1)),
            _createVNode(SogDataLabel, {
              class: "value",
              style: {"grid-column-end":"span 5","grid-column-start":"2"},
              "value-type": _unref(SogDataLabelValueType).String,
              value: __props.rechercheMessage?.versicherungsnehmer?.vereinigung?.nameVereinigung
            }, null, 8, ["value-type", "value"]),
            _cache[21] || (_cache[21] = _createElementVNode("div", { id: "label" }, " Name ", -1)),
            _createVNode(SogDataLabel, {
              class: "value",
              "value-type": _unref(SogDataLabelValueType).String,
              value: __props.rechercheMessage?.versicherungsnehmer?.natuerlichePerson?.nachname
            }, null, 8, ["value-type", "value"]),
            _cache[22] || (_cache[22] = _createElementVNode("div", { id: "label" }, " Akad. Grad ", -1)),
            _createVNode(SogDataLabel, {
              class: "value",
              "value-type": _unref(SogDataLabelValueType).String
            }, null, 8, ["value-type"]),
            _cache[23] || (_cache[23] = _createElementVNode("div", { id: "label" }, " Postleitzahl ", -1)),
            _createVNode(SogDataLabel, {
              class: "value",
              "value-type": _unref(SogDataLabelValueType).String,
              value: __props.rechercheMessage?.versicherungsnehmer?.anschrift?.postleitzahl
            }, null, 8, ["value-type", "value"]),
            _cache[24] || (_cache[24] = _createElementVNode("div", { id: "label" }, " Namensbest. ", -1)),
            _createVNode(SogDataLabel, {
              class: "value",
              "value-type": _unref(SogDataLabelValueType).String
            }, null, 8, ["value-type"]),
            _cache[25] || (_cache[25] = _createElementVNode("div", { id: "label" }, " Straße ", -1)),
            _createVNode(SogDataLabel, {
              class: "value",
              "value-type": _unref(SogDataLabelValueType).String,
              value: __props.rechercheMessage?.versicherungsnehmer?.anschrift?.strasse
            }, null, 8, ["value-type", "value"]),
            _cache[26] || (_cache[26] = _createElementVNode("div", { id: "label" }, " Wohnort ", -1)),
            _createVNode(SogDataLabel, {
              class: "value",
              "value-type": _unref(SogDataLabelValueType).String,
              value: __props.rechercheMessage?.versicherungsnehmer?.anschrift?.wohnort
            }, null, 8, ["value-type", "value"]),
            _cache[27] || (_cache[27] = _createElementVNode("div", { id: "label" }, " Vorname ", -1)),
            _createVNode(SogDataLabel, {
              class: "value",
              "value-type": _unref(SogDataLabelValueType).String,
              value: __props.rechercheMessage?.versicherungsnehmer?.natuerlichePerson?.vorname
            }, null, 8, ["value-type", "value"]),
            _cache[28] || (_cache[28] = _createElementVNode("div", { id: "label" }, " Hausnummer ", -1)),
            _createVNode(SogDataLabel, {
              class: "value",
              "value-type": _unref(SogDataLabelValueType).String,
              value: __props.rechercheMessage?.versicherungsnehmer?.anschrift?.hausnummer
            }, null, 8, ["value-type", "value"]),
            _cache[29] || (_cache[29] = _createElementVNode("div", { id: "label" }, " Staat ", -1)),
            _createVNode(SogDataLabel, {
              class: "value",
              "value-type": _unref(SogDataLabelValueType).String,
              value: __props.rechercheMessage?.versicherungsnehmer?.anschrift?.staat
            }, null, 8, ["value-type", "value"]),
            _cache[30] || (_cache[30] = _createElementVNode("div", { id: "label" }, " Geschlecht ", -1)),
            _createVNode(SogDataLabel, {
              class: "value",
              "value-type": _unref(SogDataLabelValueType).String,
              value: __props.rechercheMessage?.versicherungsnehmer?.natuerlichePerson?.geschlecht
            }, null, 8, ["value-type", "value"]),
            _cache[31] || (_cache[31] = _createElementVNode("div", { id: "label" }, " Adr. Zusatz ", -1)),
            _createVNode(SogDataLabel, {
              class: "value",
              "value-type": _unref(SogDataLabelValueType).String,
              value: __props.rechercheMessage?.versicherungsnehmer?.anschrift?.adressierungszusaetze
            }, null, 8, ["value-type", "value"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(SogCard, { class: "card" }, {
      default: _withCtx(() => [
        _createVNode(SogCardTitle, { id: "title" }, {
          default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
            _createTextVNode(" Halter ", -1)
          ]))]),
          _: 1
        }),
        _createVNode(SogCardContent, { id: "content-container" }, {
          default: _withCtx(() => [
            _cache[33] || (_cache[33] = _createElementVNode("div", {
              id: "label",
              style: {"grid-column-end":"span 3","grid-column-start":"0"}
            }, " Halter weicht vom Versicherungsnehmer ab? ", -1)),
            _createVNode(SogDataLabel, {
              class: "value",
              "value-type": _unref(SogDataLabelValueType).String,
              value: __props.rechercheMessage?.halter?.halterAbweichendVonVersicherungsnehmer ? 'Ja' : 'Nein'
            }, null, 8, ["value-type", "value"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(SogCard, { class: "card" }, {
      default: _withCtx(() => [
        _createVNode(SogCardTitle, { id: "title" }, {
          default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
            _createTextVNode(" Kennzeichen ", -1)
          ]))]),
          _: 1
        }),
        _createVNode(SogCardContent, { id: "content-container" }, {
          default: _withCtx(() => [
            _cache[35] || (_cache[35] = _createElementVNode("div", { id: "label" }, " Zulässige Kennzeichenarten ", -1)),
            _createVNode(SogDataLabel, {
              class: "value",
              style: {"grid-column-end":"span 3","grid-column-start":"0"},
              "value-type": _unref(SogDataLabelValueType).String,
              value: __props.rechercheMessage?.kennzeichen?.merkmalKennzeichenart
            }, null, 8, ["value-type", "value"]),
            _cache[36] || (_cache[36] = _createElementVNode("div", { id: "label" }, " Saisonende ", -1)),
            _createVNode(SogDataLabel, {
              class: "value",
              "value-type": _unref(SogDataLabelValueType).String,
              value: __props.rechercheMessage?.kennzeichen?.kennzeichenString
            }, null, 8, ["value-type", "value"]),
            _cache[37] || (_cache[37] = _createElementVNode("div", { id: "label" }, " Kennzeichen ", -1)),
            _createVNode(SogDataLabel, {
              class: "value",
              "value-type": _unref(SogDataLabelValueType).String,
              value: __props.rechercheMessage?.kennzeichen?.kennzeichenBisher
            }, null, 8, ["value-type", "value"]),
            _cache[38] || (_cache[38] = _createElementVNode("div", { id: "label" }, " Saisonbeginn ", -1)),
            _createVNode(SogDataLabel, {
              class: "value",
              "value-type": _unref(SogDataLabelValueType).String,
              value: __props.rechercheMessage?.kennzeichen?.kennzeichenBisher
            }, null, 8, ["value-type", "value"]),
            _cache[39] || (_cache[39] = _createElementVNode("div", { id: "label" }, " Ablauftage Kurzz. ", -1)),
            _createVNode(SogDataLabel, {
              class: "value",
              "value-type": _unref(SogDataLabelValueType).String,
              value: __props.rechercheMessage?.kennzeichen?.ablauftageKurzzeitkennzeichen
            }, null, 8, ["value-type", "value"]),
            _cache[40] || (_cache[40] = _createElementVNode("div", { id: "label" }, " Kennzeichen gültig bis ", -1)),
            _createVNode(SogDataLabel, {
              class: "value",
              "value-type": _unref(SogDataLabelValueType).Date,
              value: __props.rechercheMessage?.kennzeichen?.datumKennzeichenGueltigBis
            }, null, 8, ["value-type", "value"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(SogCard, { class: "card" }, {
      default: _withCtx(() => [
        _createVNode(SogCardTitle, { id: "title" }, {
          default: _withCtx(() => [...(_cache[41] || (_cache[41] = [
            _createTextVNode(" Fahrzeug ", -1)
          ]))]),
          _: 1
        }),
        _createVNode(SogCardContent, { id: "content-container" }, {
          default: _withCtx(() => [
            _cache[42] || (_cache[42] = _createElementVNode("div", { id: "label" }, " FZ-Art ", -1)),
            _createVNode(SogDataLabel, {
              class: "value",
              "value-type": _unref(SogDataLabelValueType).String,
              value: __props.rechercheMessage?.fahrzeug?.fahrzeugartDescription
            }, null, 8, ["value-type", "value"]),
            _cache[43] || (_cache[43] = _createElementVNode("div", { id: "label" }, " FIN ", -1)),
            _createVNode(SogDataLabel, {
              class: "value",
              style: {"grid-column-end":"span 5","grid-column-start":"4"},
              "value-type": _unref(SogDataLabelValueType).String,
              value: __props.rechercheMessage?.fahrzeug?.fahrzeugidentifizierungsnummer
            }, null, 8, ["value-type", "value"]),
            _cache[44] || (_cache[44] = _createElementVNode("div", { id: "label" }, " HSN ", -1)),
            _createVNode(SogDataLabel, {
              class: "value",
              "value-type": _unref(SogDataLabelValueType).String,
              value: __props.rechercheMessage?.fahrzeug?.schluesselHersteller
            }, null, 8, ["value-type", "value"]),
            _cache[45] || (_cache[45] = _createElementVNode("div", { id: "label" }, " Variante ", -1)),
            _createVNode(SogDataLabel, {
              class: "value",
              style: {"grid-column-end":"span 5","grid-column-start":"4"},
              "value-type": _unref(SogDataLabelValueType).String,
              value: __props.rechercheMessage?.fahrzeug?.schluesselVarianteVersion
            }, null, 8, ["value-type", "value"]),
            _cache[46] || (_cache[46] = _createElementVNode("div", { id: "label" }, " TSN ", -1)),
            _createVNode(SogDataLabel, {
              class: "value",
              "value-type": _unref(SogDataLabelValueType).String,
              value: __props.rechercheMessage?.fahrzeug?.schluesselTyp
            }, null, 8, ["value-type", "value"]),
            _cache[47] || (_cache[47] = _createElementVNode("div", { id: "label" }, " Zulässige Verwendungszwecke ", -1)),
            _createVNode(SogDataLabel, {
              class: "value",
              style: {"grid-column-end":"span 5","grid-column-start":"4"},
              "value-type": _unref(SogDataLabelValueType).String,
              value: __props.rechercheMessage?.fahrzeug?.verwendungFahrzeug
            }, null, 8, ["value-type", "value"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(SogCard, { class: "card" }, {
      default: _withCtx(() => [
        _createVNode(SogCardTitle, { id: "title" }, {
          default: _withCtx(() => [...(_cache[48] || (_cache[48] = [
            _createTextVNode(" Verarbeitungshistorie ", -1)
          ]))]),
          _: 1
        }),
        _createVNode(SogGrid, {
          "allow-filtering": true,
          "allow-paging": false,
          columns: [
          {..._unref(DateTimeColumn), field: 'zeitpunktVerarbeitungsschritt', headerText: 'Zeitpunkt'},
          {..._unref(DefaultColumn), field: 'verarbeitungsschritt', headerText: 'Arbeitsschritt', width: '70%'},
          {..._unref(DefaultColumn), field: '', headerText: 'Detail'},
        ],
          data: __props.rechercheMessage?.listeVbVerarbeitungshistorie
        }, null, 8, ["columns", "data"])
      ]),
      _: 1
    })
  ]))
}
}

})